<app-public-layout-wrapper>
  <div leftside class="container-side-left">
    <div class="title-side-left">{{ 'remember.salut' | translate }}</div>
    <div class="footer-side-left">
      <div class="title-bold">
        {{ 'register.already-have-an-account' | translate }}
      </div>
      <app-button
        class="ind-btn-wrapper-100"
        className="ind-btn ind-btn--secondary"
        type="submit"
        label="buttons.labels.signin"
        [routerLink]="loginPath"></app-button>
    </div>
  </div>
  <ng-container rightside>
    <app-header-public></app-header-public>
    <app-remember-form (submitForm)="onSubmit($event)"></app-remember-form>
  </ng-container>
</app-public-layout-wrapper>
